import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=5a20b27e"
import script from "./TenantForm.vue?vue&type=script&lang=js"
export * from "./TenantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports